export const BACKEND = import.meta.env.REACT_APP_BASEURL
export const FRONTEND = import.meta.env.REACT_APP_FRONTEND_URL
export const KISS_SIGN_URL = import.meta.env.REACT_APP_SIGN_URL
export const STRIPE_WEBHOOK_ENDPOINT_BASEURL = import.meta.env.REACT_APP_STRIPE_WEBHOOK_ENDPOINT_BASE_URL
export const CUSTOMER_PORTAL_BASEURL = import.meta.env.REACT_APP_CUSTOMER_PORTAL_URL
